import React from "react";
import { DatePicker } from "antd";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";

class DailyTravelChargesModal extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            date: null
        };

        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    handleChangeDate(date) {
        this.setState({
            date
        });
    }

    handleConfirm() {
        if (this.validator.allValid()) {
            const dateString = this.state.date ? this.state.date.format(this.dateFormat) : null;
            this.props.onProcess(dateString);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        return (
            <div>
                <div className="row justify-content-center pb-3">
                    <div className="col-12">
                        <label className="mb-2">Select Date:</label>
                        <DatePicker
                            format={this.dateFormat}
                            value={this.state.date}
                            onChange={this.handleChangeDate}
                            placeholder="Select date"
                            className="w-100"
                        />
                        {this.validator.message("date", this.state.date, "required")}
                    </div>
                </div>
                <hr />

                <div className="text-right">
                    <button className="btn btn-success ml-2" onClick={this.handleConfirm}>
                        Ok
                    </button>
                    <button className="btn btn-outline-primary ml-2" onClick={this.props.onCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        );
    }
}

export default DailyTravelChargesModal;

